import React from "react";
import QuotaDetail from "components/Tvendo/Sale/DataMaster/Quota/QuotaDetail/List.js";

export default function () {
  return <QuotaDetail />;
}
